import React, { useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { CircularProgress, Box, Typography } from '@mui/material';
import { useAuth } from '../../context/AuthContext';

function GoogleCallback() {
  const navigate = useNavigate();
  const location = useLocation();
  const { login } = useAuth();

  useEffect(() => {
    const handleCallback = async () => {
      const params = new URLSearchParams(location.search);
      const token = params.get('token');
      const error = params.get('error');

      if (error) {
        navigate('/login?error=auth_failed', { replace: true });
        return;
      }

      if (!token) {
        navigate('/login?error=no_token', { replace: true });
        return;
      }

      try {
        // Store token
        localStorage.setItem('token', token);
        await login();

        navigate('/dashboard', { replace: true });
      } catch (error) {
        navigate('/login?error=session_init_failed', { replace: true });
      }
    };

    handleCallback();
  }, [location, login, navigate]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        gap: 2
      }}
    >
      <CircularProgress />
      <Typography>
        Completing sign in...
      </Typography>
    </Box>
  );
}

export default GoogleCallback; 